import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { SmartReport } from "@/components/smart-report/SmartReport";
import { useInventoryFilter } from "@/lib/inventory-filter";
import { useDashboardStats } from "@/lib/api/useDashboardStats";
import { useFilteredBuildings } from "@/lib/inventory-scope";

export const Route = createFileRoute("/reports")({
  component: ReportsPage,
});

// Kiinteistöraportti — a deterministic template artifact:
// named template + ScopeBar scope + window → fixed WidgetSpec[]. No prompt, no LLM.
function ReportsPage() {
  const { buildingId } = useInventoryFilter();
  const stats = useDashboardStats();
  const candidateBuildings = useFilteredBuildings(
    stats.status === "ok" ? stats.buildings : [],
  );

  return (
    <Shell
      title="Kiinteistöraportti"
      subtitle="Nimetty malli, laajuus ja jakso"
    >
      <div className="flex flex-col gap-4">
        <SmartReport
          buildingId={buildingId}
          candidateBuildings={candidateBuildings}
        />
      </div>
    </Shell>
  );
}
